export default __webpack_public_path__ + "static/preview-2e06d5d36a9aa252531fca4a306cdbca.png";